module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Media/Youtube-4595b93fba216ce5d24d86d0207b131c.svg";